<template>
  <div>
    <v-btn
      class="mt-3 ml-0 pl-0 mb-0 pb-0"
      elevation="0"
      small
      light
      color="transparent"
      @click="goBack"
    >
      <v-icon
        size="25"
        color="#000"
      >
        mdi mdi-chevron-left
      </v-icon>Back
    </v-btn>
    <h1 class="header-style">
      Notes
    </h1>
    <p class="subheader-style">
      {{ jobDetails.name }}
    </p>
    <job-comments />
  </div>
</template>

<script>
import jobComments from '../Components/dialogComponents/JobsDialogs/JobComments.vue';
export default {
  name: 'JobCommentsPage',
  components: {
    'job-comments': jobComments,
  },
  computed: {
    jobDetails () {
      return this.$store.getters['jobs/getJobDetails'];
    },
  },
  async mounted () {
    await this.getJobDetails();
  },
  methods: {
    async getJobDetails () {
      this.loading = true;
      const jobId = this.$route.params.jobId;
      await this.$store.dispatch('jobs/fetchJobDetails', {
        jobId: jobId,
      });
      this.loading = false;
    },
    goBack () {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
